import React from "react";
import { trialClassCheckoutRoute } from "../../utils";
import { navigate } from "@reach/router";
import logotipoBlanco from "../../assets/rebrand/logotipo-blanco.png";
import LandingNavbar from "./LandingNavbar";
import MobileNavbar from "./MobileNavbar";

const MonterreyLandingVideo = ({ branch_id, presencialCityName }) => {
  return (
    <div
      id="scrollspyHero"
      className="monterrey-landing__container container-fluid m-0 w-100 position-relative"
    >
      <div className="pt-3 position-absolute d-flex flex-column start-0 end-0 container__content-container">
        <LandingNavbar />
        <MobileNavbar branch_id={branch_id} />

        <div className="content-container__description ">
          <div className="d-flex flex-column align-items-start description__head position-relative">
            <h2 className="head__desc">
              Descubre una versión más fuerte de ti, por dentro y por fuera
            </h2>
            <img
              src={logotipoBlanco}
              alt="The Body Method"
              className="head__logotipo"
            />
            <p
              style={{ borderRadius: "15px", padding: "8px 32px" }}
              className={`head__city px-2 ${branch_id === 1 ? "bg-primary text-white" : "bg-blue text-dark"}`}
            >
              <span className="px-3">{presencialCityName}</span>
            </p>
          </div>

          <div className="mt-3 landing-content">
            <p className="h3 text-white bold">ENTRENA EN NUESTRO STUDIO</p>
            <p className="text-white" style={{ fontSize: "20px" }}>
              Vive una experiencia de entrenamiento donde fuerza, resistencia,
              movilidad y cardio se integran en un mismo espacio para ayudarte a
              construir un cuerpo más fuerte, más capaz y una relación más
              consciente contigo misma a través del movimiento.
            </p>
          </div>

          <div
            className="description__bottom d-flex justify-content-center mt-4"
          >
            <button
              type="button"
              className={`btn monterrey-landing__cta bold ${branch_id === 2 ? "bg-gradient-landing--tijuana text-dark" : "bg-gradient-landing text-white"}`}
              onClick={() => navigate(`/checkout/${branch_id === 2 ? "19301" : "19413"}`)}
            >
              AGENDA TU CLASE DE PRUEBA
              <i className="fas fa-arrow-right ms-2" />
            </button>
          </div>
        </div>
      </div>

      <img
        className="mw-100 w-100 container__video"
        src={`https://thebodymethod.s3.us-west-1.amazonaws.com/${
          branch_id === 2 ? "tj-cover.jpg" : "tbmmty-hero-2.jpg"
        }`}
        data-object-fit="cover"
        alt="hero"
      />
    </div>
  );
};

export default MonterreyLandingVideo;
